export default "__VITE_ASSET__BpXKrvdZ__"